import Swiper from 'swiper/js/swiper';
import { getCurrentDevice, videoControlPlayer, $win } from './utils';

/**
 * @param {string} selector
 * @param {object} [options={}]
 * @param {HTMLElement|undefined} container
 */
export const initSlider = (selector, options = {}, container) => {
	$(selector, container).each(function() {
		const $sliderWrap = $(this);
		const $slider = $sliderWrap.find('.swiper-container');
		const $paging = $sliderWrap.find('.js-paging');
		const $items = $sliderWrap.find('.swiper-slide');
		const $totalEl = $sliderWrap.find('.js-total');
		const $currentEl = $sliderWrap.find('.js-current');
		const shouldAutorotate = $sliderWrap.data('autorotate') && $sliderWrap.find('iframe').length === 0;
		const $btnAutoplay = $sliderWrap.find('.js-slider-autoplay');
		const autoplaySpeed = parseInt($sliderWrap.data('playspeed'));
		const hasSlideToNext = $sliderWrap.data('slide-to-next') ? $sliderWrap.data('slide-to-next') : false;
		let lastActiveRealIndex = 0;

		const localOptions = {
			slidesPerView: 1,
			loop: true,
			loopedSlides: 5,
			speed: 500,
			simulateTouch: false,
			preloadImages: false,
			lazy: {
				loadPrevNext: true,
			},
			navigation: {
				prevEl: $paging.find('.js-paging-prev'),
				nextEl: $paging.find('.js-paging-next'),
			},
			pagination: {
				el: $slider.find('.js-slider-bullets'),
				type: 'bullets',
				clickable: true
			},
			...options
		}

		let slidesPerViewMobile = localOptions.slidesPerView;
		let slidesPerViewTablet = (localOptions.breakpoints && localOptions.breakpoints[1025] && localOptions.breakpoints[1025].slidesPerView) || slidesPerViewMobile;
		let slidesPerViewDesktop = (localOptions.breakpoints && localOptions.breakpoints[768] && localOptions.breakpoints[768].slidesPerView) || slidesPerViewTablet;

		if ( $sliderWrap.find('iframe').length ) {
			$sliderWrap.addClass('has-video');
		}

		let limit;

		switch (getCurrentDevice()) {
			case 'tablet':
				limit = slidesPerViewMobile;
				break;
			case 'mobile':
				limit = slidesPerViewTablet;
			default:
				limit = slidesPerViewDesktop;
		}
		
		const disableSlider = () => {
			$sliderWrap.addClass('not-initialized');

			localOptions.loop = false;
			localOptions.centeredSlides = false;
			localOptions.allowTouchMove = false;

			$totalEl.parent().addClass('hidden');
		}

		/* If there is only one item we hide the pagination (CSS)
			 * and stop the loop or anything allowing to slide */
		if (localOptions.slidesPerView !== 'auto') {
			if ($items.length <= limit) disableSlider();
		} else {
			if ($items.length == 1) disableSlider();
		}

		if ( shouldAutorotate ) {

			if(autoplaySpeed){
				localOptions.autoplay = {delay : autoplaySpeed};
			}else{
				localOptions.autoplay = true;
			}

			$btnAutoplay.addClass('playing');
		}

		if ( selector == '.js-slider-highlight-images') {
			let hasPlayed = false;

			$win.on('scroll', function() {
				if ( $sliderWrap.offset().top < $win.height() + $win.scrollTop() ) {
					if ( !hasPlayed ) {
						videoControlPlayer($slider.find('.swiper-slide-active iframe'), 'play');

						hasPlayed = true;
					}
				}
			});

			if ( $slider.find('iframe').length ) {
				localOptions.autoplay = false;
			}
		}

		$totalEl.text($items.length);
		$currentEl.text(1);

		const slider = new Swiper ($slider, localOptions);

		slider.on('slideChange', () => {
			setTimeout(() => {
				$currentEl.text(slider.realIndex + 1);
			}, 100);
		});

		$('.modal').on('shown.bs.modal', function() {
			slider.update();

			// Trigger iframe position re-calculation
			setTimeout(function() {
				$(window).trigger('resize');
			}, 400)
		});

		slider.on('slideChangeTransitionStart', function () {
            const $activeSlide = $slider.find('.swiper-slide-active');
            const $previousSlideLoops = $slider.find(`.swiper-slide[data-swiper-slide-index="${lastActiveRealIndex}"]`);
            if (!localOptions.preventVideoAutoplay) {
                if (localOptions.delayVideoAutoplay) {
                	setTimeout(() => {
                    	videoControlPlayer($('iframe', $activeSlide), 'play');
                	}, 300)
                } else {
                	videoControlPlayer($('iframe', $activeSlide), 'play');
                }

            }
            videoControlPlayer($('iframe', $previousSlideLoops), 'pause');

            lastActiveRealIndex = slider.realIndex;
        });

        $btnAutoplay.on('click', () => {
			if (slider.autoplay.running) {
				slider.autoplay.stop();
				$btnAutoplay.removeClass('playing')
			} else {
				slider.autoplay.start();
				$btnAutoplay.addClass('playing')
			}
		});

		$paging.find('.js-paging-prev, .js-paging-next').on('click', () => {
			$btnAutoplay.removeClass('playing');
		});

		slider.on('click', function(event) {
			const $target = $(event.target);

			if ( hasSlideToNext && (getCurrentDevice() == 'mobile' || getCurrentDevice() == 'tablet') ) {
			
				if ( !$target.is('button') && 
					 !$target.is('a') && 
					 !$target.hasClass('swiper-pagination-bullet') &&
					 !$target.parents('button').length &&
					 !$target.parents('a').length
					) {
					slider.slideNext();
				}
			}
		});
	});

}

/**
 *
 * @param {HTMLElement} [container] Optional container to only init sliders in container
 */
export default container => {
	initSlider('.js-slider-demo', {}, container);

	initSlider('.js-slider-awards', {
		slidesPerView: 2,
	}, container);

	initSlider('.js-slider-gallery', {
		slidesPerView: 1,
		delayVideoAutoplay: true
	}, container);

	initSlider('.js-slider-items', {
		slidesPerView: 1,
		spaceBetween: 20,
		loopedSlides: 20,
		breakpoints: {
			768: {
				slidesPerView: 3,
			}
		}
	}, container);

	initSlider('.js-slider-highlight-images', {
		preventVideoAutoplay: true
	}, container);

	initSlider('.js-slider-buttons', {
		slidesPerViewDesktop: 5,
		slidesPerViewTablet: 3,
		breakpoints: {
			768: {
				slidesPerView: 3,
			},
			1025: {
				slidesPerView: 5,
			}
		}

	}, container);

	initSlider('.js-slider-reviews', {
		effect: 'fade',
		fadeEffect: {
			crossFade: true,
		},
	}, container);




	initSlider('.js-slider-benefit-categories', {
		loop: false,
		slidesPerView: 'auto'
	}, container);
}
